//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import qs from 'qs'
import Window from '../utils/Window'
import Cookie from '../utils/Cookie'

// 是否是H5渠道
let h5 = false

let timer = null
export default {
  name: 'm-order',
  data () {
    return {
      agreeTerms: true,
      Window: Window,
      h5: h5,
      showTicket: false,
      isUseCoupon: false
    }
  },
  mounted () {
    this.$store.commit('updateProductId', this.$route.params.productId)
    this.$store.commit('updateUserId', this.$route.params.userId)
    // this.$store.commit('updateOrderOpenId', this.$route.params.openId)

    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.h5 = true
    }

    this.$store.commit('updateOrderUnionOrderCode', this.$route.params.unionCode)

    const data = {}
    if (this.$route.query.activityCode) {
      data.activityCode = this.$route.query.activityCode
    }
    this.$http.get((this.h5 ? '/api/channel/hqdqx/orderQueren/' : '/api/hqdqx/orderQueren/') + this.$store.state.order.userId + '/' + this.$store.state.order.productId + '/' + this.$store.state.order.unionOrderCode + '?' + qs.stringify(data)).then(response => {
      this.$store.commit('updateOrderName', response.data.busProductRelation.productName)
      this.$store.commit('updateOrderCompany', response.data.busProductRelation.suppliername)
      this.$store.commit('updateOrderNumber', response.data.busOrder.orderCode)
      this.$store.commit('updateInsuredName', response.data.underwritingInfoList[0].policyInsured.insuredName)
      this.$store.commit('updateInsuredIDNumber', response.data.underwritingInfoList[0].policyInsured.insuredIdNumber)
      this.$store.commit('updateOrderInsuranceAmount', response.data.underwritingInfoList[0].coverageMultiples / 100 + '')
      this.$store.commit('updateOrderPaymentPeriod', response.data.underwritingInfoList[0].insurePayWay + '')
      this.$store.commit('updateOrderInsurancePeriod', response.data.underwritingInfoList[0].durationPeriodValue + '')
      this.$store.commit('updateHolderPhoneNumber', response.data.underwritingInfoList[0].policyHolder.holderPhone)
      this.$store.commit('updatePaymentByIDNumber', response.data.underwritingInfoList[0].premium / response.data.underwritingInfoList[0].coverageMultiples)
      this.isUseCoupon = response.data.isUseCoupon === 1
      const passSeconds = Math.floor((Date.now() - response.data.orderCreateDate) / 1000)
      const countdownTimer = 1800 - passSeconds
      this.$store.commit('updateOrderCountdownTimer', countdownTimer < 0 ? 0 : countdownTimer)
      timer = setInterval(() => {
        if (this.$store.state.order.countdownTimer <= 0) {
          clearInterval(timer)
        }
        this.$store.commit('updateOrderCountdownTimer', this.$store.state.order.countdownTimer - 1)
      }, 1000)

      // 获取券的信息
      if (this.$store.state.activity.tickets.length === 0) {
        this.$http.post('/api/coupon/getUserValidCouponCount', qs.stringify({'productCode': this.$store.state.order.productId, orderCode: response.data.underwritingInfoList[0].orderCode, 'openid': Cookie.getCookie('session_wechat_user_openid')})).then((response) => {
          if (response.data.data && response.data.data.length > 0) {
            this.$store.commit('updateActivityTickets', response.data.data)
          }
        })
      }
    })
    document.title = '订单确认'
  },
  destroyed () {
    clearInterval(timer)
  },
  computed: {
    orderName () {
      return this.$store.state.order.name
    },
    orderCompany () {
      return this.$store.state.order.company
    },
    orderNumber () {
      return this.$store.state.order.number
    },
    holderName () {
      return this.$store.state.holder.name
    },
    holderIDNumber () {
      return this.$store.state.holder.IDNumber
    },
    insuredName () {
      return this.$store.state.insured.name
    },
    insuredIDNumber () {
      return this.$store.state.insured.IDNumber
    },
    insuranceAmountName () {
      return this.$store.getters.insuranceAmountName
    },
    paymentPeriodName () {
      return this.$store.getters.paymentPeriodName
    },
    insurancePeriodName () {
      return this.$store.getters.insurancePeriodName
    },
    paymentMethodName () {
      return this.$store.getters.paymentMethodName
    },
    paymentByIDNumber () {
      return this.$store.getters.computPaymentByIDNumber
    },
    beneficiary () {
      return this.$store.state.order.beneficiary
    },
    tickedBtnText () {
      if (this.$store.getters.selectedTickets.length > 0) {
        return '您已使用' + this.$store.getters.selectedTickets.length + '张券,已优惠' + this.$store.state.activity.amountBySelectedTickets + '元'
      }
      return '有' + this.$store.state.activity.tickets.length + '张可用'
    }
  },
  methods: {
    payNow () {
      // 订单逾期
      if (this.$store.state.order.countdownTimer <= 0) {
        const that = this
        this.$vux.confirm.show({
          confirmText: '重新下单',
          title: '订单逾期',
          content: '订单逾期，请重新下单！',
          onConfirm () {
            that.$router.push({name: 'Form', params: {productId: that.$store.state.order.productId, userId: that.$store.state.order.userId}, query: that.$route.query})
          }
        })
        return
      }

      if (!this.agreeTerms) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请您认真阅读理解并同意相关内容后再试',
          position: 'top',
          width: '20em'
        })
        return
      }

      this.$vux.loading.show({
        text: '正在提交'
      })
      // 活动
      let judgeURL = (this.h5 ? '/api/channel/illness/judgeInsurance/' : '/api/illness/judgeInsurance/') + this.$store.state.order.unionOrderCode
      judgeURL += '?innerCode=' + this.$store.state.order.userId
      if (this.$store.state.activity.status && this.$store.state.activity.innerCodes.indexOf(this.$store.state.order.userId) !== -1) {
        if (this.$store.getters.selectedTickets.length > 0) {
          let coupons = ''
          this.$store.getters.selectedTickets.forEach((ele) => {
            coupons += ele.couponCode + ','
          })
          coupons = coupons.substring(0, coupons.length - 1)
          judgeURL += '&coupons=' + coupons
        }
        judgeURL += '&openid=' + Cookie.getCookie('session_wechat_user_openid')
      }
      this.$http.get(judgeURL).then(response => {
        this.$vux.loading.hide()
        if (response.data[0].undwrtStatus === 0) {
          this.$vux.toast.show({
            type: 'text',
            text: '客官，正在核保中，请稍后再试',
            position: 'top',
            width: '20em'
          })
          return
        }
        if (response.data[0].undwrtStatus === 2) {
          this.$vux.alert.show({
            title: '核保失败',
            content: response.data[0].undwrtMsg || '核保超时',
            buttonText: '知道了'
          })
          return
        }
        this.$router.push({name: 'Pay', params: {productId: this.$store.state.order.productId, userId: this.$store.state.order.userId, unionCode: this.$store.state.order.unionOrderCode}, query: this.$route.query})
      })
    },
    showTickets () {
      if (this.$store.state.activity.tickets.length > 0) {
        this.showTicket = true
        return
      }
      this.$vux.toast.show({
        type: 'text',
        text: '客官，您没有可用的优惠券',
        position: 'top',
        width: '20em'
      })
    },
    ticketType (value) {
      if (value === 1) {
        return '现金券'
      } else if (value === 2) {
        return '折扣券'
      } else if (value === 5) {
        return '现金券'
      } else if (value === 6) { // 通用折扣券
        return '折扣券'
      }
      // if (value === 'all_products') {
      //   return '通用券'
      // } else if (value === 1 || value === 5) {
      //   return '现金券'
      // }
      // return '定向券'
    },
    ticketValue (type, value) {
      if (type === 1 || type === 5) {
        return value / 100 + '元'
      } else if (type === 2 || type === 6) {
        return value / 10 + '折'
      }
    },
    selectTicket (index) {
      this.$store.commit('updateTicketSelectedStatus', index)
      // 计算优惠金额
      if (this.$store.getters.selectedTickets.length === 0) {
        this.$store.commit('updateAmountBySelectedTickets', 0)
        return
      }
      const data = {coupons: '', orderSum: this.paymentByIDNumber * 100, openid: Cookie.getCookie('session_wechat_user_openid')}
      this.$store.getters.selectedTickets.forEach((ele) => {
        data.coupons += ele.couponCode + ','
      })
      data.coupons = data.coupons.substring(0, data.coupons.length - 1)
      this.$http.post('/api/coupon/calcUserChoseCoupon', qs.stringify(data)).then((response) => {
        this.$store.commit('updateAmountBySelectedTickets', Number(response.data) / 100)
      })
    },
    sureTicket () {
      this.showTicket = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Order.vue